export const CACHE_ITEM_BEFORE_UPDATE = 'CACHE_ITEM_BEFORE_UPDATE';
export const PRIMARY = 'PRIMARY';
